
<template>
  <div>
    <v-toolbar flat color="white">
      <ChecklistForm
        :addButton="true"
        :dialog="serviceDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveService="(data) => saveService(data)"
        :editFormData="formData"
      />
    </v-toolbar>

    <SearchChecklists :searchServices="(service) => initialize(service)" />

    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>

        <td class="text-xs-center">{{ props.item.created_date | moment("DD/MM/YYYY") }}</td>

        <td class="text-xs-center layout">
          <v-icon small class="mr-2" @click="editItem(props.item)" v-if="permissions.edit">edit</v-icon>
          <v-icon small @click="confirmDelService(props.item)" v-if="permissions.remove">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ChecklistForm from './ChecklistForm.vue'
import SearchChecklists from './SearchChecklists.vue'
import { getChecklists } from '@/services/checklists'

export default {
  name: 'Checklists',

  components: {
    ChecklistForm,
    SearchChecklists
  },

  data () {
    return {
      serviceDialog: false,
      formData: null,
      headers: [
        { text: 'Checklist', sortable: true, value: 'name' },
        {
          text: 'Data de criação',
          value: 'created_date',
          sortable: false,
          align: 'center'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  mounted () {
    this.initialize()
  },
  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.standardSystem
    }
  },
  methods: {
    confirmDelService (data) {
      let obj = {
        message: `Você deseja excluir o checklist "${data.name}"?`,
        title: 'Excluir checklist',
        callback: _ => {
          this.delService(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delService (data) {
      let obj = {
        url: '/api/checklist?id=' + data.id,
        query: '',
        method: 'delete'
      }

      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Checklist removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.initialize()
      })
    },

    openDialogForm () {
      this.formData = null
      this.serviceDialog = true
    },

    closeDialogForm () {
      this.serviceDialog = false
    },

    async initialize (service = { name: '' }) {
      this.tableData = await getChecklists(service.name)
    },

    editItem (item, view) {
      // if (!item.permissions_id) {
      //   item.permissions_id = item.permissions.map(perm => {
      //     return perm.id;
      //   });
      // }
      view === 'viewForm' ? (item.view = true) : (item.view = false)
      this.formData = Object.assign({}, item)
      this.serviceDialog = true
    },

    saveService (data) {
      let id = data.id ? `/${data.id}` : ''
      let typeMethod = data.id ? 'put' : 'post'

      // data.type = "master";
      // data.profile_id = 1;

      let obj = {
        url: '/api/checklist',
        query: data,
        method: typeMethod
      }

      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Checklist ${id ? 'alterado' : 'criado'} com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.serviceDialog = false
        this.initialize()
      })
    }
  }
}
</script>
